var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-box"},[_c('div',[_vm._v("请使用对应的app进行扫码")]),_vm._v(" "),_c('vue-qr',{staticClass:"qr-code",attrs:{"logoSrc":_vm.imageUrl,"text":_vm.qrCodeUrl,"size":150}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }